import React from "react";

export interface ReceiptItemConfig {
  type: "printout" | "label" | "divider";
  value?: string;
  content?: React.ReactNode;
  className?: string;
}

export const RECEIPT_HALL_SECTIONS: ReceiptItemConfig[] = [
  {
    type: "printout",
    value: "title", // receiptData.title
    content: <span>배달의민족 알뜰배달</span>,
    className: "title",
  },
  {
    type: "printout",
    value: "channelNo", // receiptData.channelNo
    content: <span>채널주문번호 P1XD</span>,
  },
  {
    type: "printout",
    value: "posNo", // receiptData.posNo
    content: <span>포스주문번호 A023</span>,
  },

  { type: "divider" },
  { type: "label", content: "배달주소" },
  {
    type: "printout",
    value: "loadAdr", // receiptData.loadAdr
    content: <span>서울특별시 중구 세종대로 110 서울시청</span>,
  },
  {
    type: "printout",
    value: "adress", // receiptData.adress
    content: <span>(서울특별시 중구 태평로1가31 서울시청)</span>,
  },

  { type: "divider" },
  { type: "label", content: "연락처" },
  {
    type: "printout",
    value: "phone", // receiptData.phone
    content: <span>010-1234-5678</span>,
  },
  {
    type: "label",
    content: "*고객 정보 도용 시 법적 책임을 받을 수 있습니다",
  },

  { type: "divider" },
  { type: "label", content: "요청사항" },
  {
    type: "printout",
    value: "memo", // receiptData.memo
    content: <span>가게 : 짬뽕 안맵게 해주세요. [수저,포크O]</span>,
  },
  {
    type: "printout",
    value: "memo", // receiptData.memo
    content: <span>라이더 : 벨 누르지말고 문 앞에 놔주세요</span>,
  },
  {
    type: "label",
    content: "*주류 포함 주문, 신분증 확인해주세요",
  },

  { type: "divider", className: "more" },
  { type: "divider" },
  {
    type: "label",
    content: (
      <>
        <span className="menu">메뉴</span>
        <span className="cnt">수량</span>
        <span className="price">금액</span>
      </>
    ),
  },
  { type: "divider" },
  {
    type: "printout",
    value: "menu", // receiptData.menu
    content: (
      <>
        <span className="menu">차돌짬뽕</span>
        <span className="cnt">1</span>
        <span className="price">5,000</span>
      </>
    ),
  },
  {
    type: "printout",
    value: "option", // receiptData.option
    content: (
      <>
        <span className="menu">▶ 곱빼기</span>
        <span className="cnt">1</span>
        <span className="price">2,000</span>
      </>
    ),
  },
  {
    type: "printout",
    value: "menu", // receiptData.menu
    content: (
      <>
        <span className="menu">배달팝</span>
        <span className="cnt">1</span>
        <span className="price">3,000</span>
      </>
    ),
  },

  { type: "divider" },
  {
    type: "printout",
    value: "payMethod", // receiptData.payMethod
    content: (
      <>
        <span className="menu total">합계(결제완료)</span>
        <span className="price">10,000</span>
      </>
    ),
  },

  { type: "divider" },
  {
    type: "printout",
    value: "shopNm", // receiptData.shopNm
    content: <span>주문매장ㅤOKPOS 매장</span>,
  },
  {
    type: "printout",
    value: "orderTime", // receiptData.orderTime
    content: <span>주문일시ㅤ2023. 10. 20 14:30</span>,
  },
  {
    type: "printout",
    value: "orderTime", // receiptData.orderTime
    content: <span>픽업예상일시ㅤ2023. 10. 20 16:30</span>,
  },

  { type: "divider" },
  { type: "label", content: "원산지" },
  { type: "label", content: "소고기(호주), 양파(국내산)" },
  { type: "divider" },
];

export const RECEIPT_KITCHEN_SECTIONS: ReceiptItemConfig[] = [
  {
    type: "printout",
    value: "title", // receiptData.title
    content: <span>배달의민족 알뜰배달</span>,
    className: "title",
  },
  {
    type: "printout",
    value: "channelNo", // receiptData.channelNo
    content: <span>채널주문번호 P1XD</span>,
  },
  {
    type: "printout",
    value: "posNo", // receiptData.posNo
    content: <span>포스주문번호 A023</span>,
  },
  { type: "divider" },
  { type: "label", content: "요청사항" },
  {
    type: "printout",
    value: "memo", // receiptData.memo
    content: <span>가게 : 짬뽕 안맵게 해주세요. [수저,포크O]</span>,
  },
  {
    type: "printout",
    value: "memo", // receiptData.memo
    content: <span>라이더 : 벨 누르지말고 문 앞에 놔주세요</span>,
  },

  { type: "divider", className: "more" },
  { type: "divider" },
  {
    type: "label",
    content: (
      <>
        <span className="menu">메뉴</span>
        <span className="cnt">수량</span>
      </>
    ),
  },
  { type: "divider" },
  {
    type: "printout",
    value: "menu", // receiptData.menu
    content: (
      <>
        <span className="menu">차돌짬뽕</span>
        <span className="cnt">1</span>
      </>
    ),
  },
  {
    type: "printout",
    value: "option", // receiptData.option
    content: (
      <>
        <span className="menu">▶ 곱빼기</span>
        <span className="cnt">1</span>
      </>
    ),
  },
  {
    type: "printout",
    value: "menu", // receiptData.menu
    content: (
      <>
        <span className="menu">배달팁</span>
        <span className="cnt">1</span>
      </>
    ),
  },
  { type: "divider" },

  {
    type: "printout",
    value: "orderTime", // receiptData.orderTime
    content: <span>주문일시ㅤ2023. 10. 20 14:30</span>,
  },
  {
    type: "printout",
    value: "orderTime", // receiptData.orderTime
    content: <span>픽업예상일시ㅤ2023. 10. 20 16:30</span>,
  },
  { type: "divider" },
];
